import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import MatrixWidget from '@components/widget/MatrixWidget';
import TrainingWidget from '@components/widget/TrainingWidget';

const Matrix = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-laptop-house mr-2" />
        Matrix™
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <MatrixWidget />
        </Panel>
      </div>
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <TrainingWidget url="https://pillarnine.com/matrix-resources" />
        </Panel>
      </div>
    </div>
  </>
);

export default Matrix;
